// "Com vols pagar?" on the payment page Aleta makes (backend/form-auto-payment.js).
// The web can't take card payments (only the app can), so here the card isn't
// offered and the form starts with the first other way. Its answer stays the index
// of the option on the form, so the app, the sheet and the responses read it as before.
export const AUTO_PAYMENT_METHOD_ID = 'auto-payment-method';
const CARD_LABEL = 'Targeta';
// Paying in person (cash or a card terminal) was «Efectiu» on older forms
const LABELS = { Efectiu: 'En persona' };

export const isAutoPaymentMethod = (element) => Boolean(element?.autoPayment && element.id === AUTO_PAYMENT_METHOD_ID);

const sameOption = (value, index) => value !== undefined && value !== null && value !== '' && String(value) === String(index);

// The options to show, with their index on the form. A card already saved in an
// answer (paid in the app) still shows, chosen; so does a way the form has turned off
// since (`unavailable`, which the app greys out).
export const webPaymentMethodOptions = (element, value) => {
  const unavailable = element?.content?.unavailable || [];
  return (element?.content?.options || [])
    .map((label, index) => ({ label: LABELS[label] || label, index, off: label === CARD_LABEL || unavailable.includes(label) }))
    .filter(({ off, index }) => !off || sameOption(value, index))
    .map(({ label, index }) => ({ label, index }));
};

// The answers with the first way the web can take already chosen. Only for a new
// answer: a saved one keeps what it has, even with no way to pay chosen.
export const withWebDefaultMethod = (form, values, { savedAnswer = false } = {}) => {
  const element = (form?.elements || []).find((candidate) => !candidate.deleted && isAutoPaymentMethod(candidate));
  if (!element || savedAnswer) return values;
  const current = values?.[element.id];
  if (current !== undefined && current !== null && current !== '') return values;
  const first = webPaymentMethodOptions(element)[0];
  return first ? { ...(values || {}), [element.id]: first.index } : values;
};
